import { api } from "#app/http/api";
import { SimilarPartFeedbackDto } from "#modules/feedback/infra/fetchSimilarPartFeedbacks.api";
import { ApiError } from "#shared/infra/apiError";

export const deleteSimilarPartFeedback = async ({
  feedbackId,
}: {
  feedbackId: string;
}): Promise<SimilarPartFeedbackDto> => {
  const response = await api.feedback.deleteSimilarPartFeedback.mutation({
    params: { feedbackId },
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to delete SimilarPartFeedback", response.status, response.body);
};
